import React,{Component} from 'react';
import './OrderData.css';
import deadline from '../../../../image/deadline.svg'
import replace from '../../../../image/replace.svg';
import trash from '../../../../image/trash.svg';
import returnx from '../../../../image/returnx.svg'
import searchbule from '../../../../image/searchbule.svg'
import { Link} from 'react-router-dom';
import MapsNewOrder from '../../../Components/Maps/MapsNewOrder';
import { QRCode } from "react-qr-svg";
var moment = require('moment');

class OrderData extends Component{
    render(){
         
            //  console.log(this.props.state.data.reciver);
            const handle_state=[['draft','ongoing','ongoing','ongoing','ongoing','ongoing','ongoing','delivered','failed','canceled'],
                                ['failed','failed','failed','failed','failed','failed','failed','failed','failed','canceled'],
                                ['trash','trash','trash','trash','trash','trash','trash','trash','trash','canceled'],
                                ['draft','return','return','return','return','return','return','return','return','canceled'],
                                ['draft','replace','replace','replace','replace','replace','replace','replace','replace','canceled'],
                                ['draft','ongoing','ongoing','ongoing','ongoing','ongoing','ongoing','delivered','failed','canceled']
        ]
        const handle_stateAR=[['مسوده','في الطريق','في الطريق','في الطريق','في الطريق','في الطريق','في الطريق','تم التوصيل','فشلت','تم الالغاء'],
                                ['فشلت','فشلت','فشلت','فشلت','فشلت','فشلت','فشلت','فشلت','فشلت','تم الالغاء'],
                                ['مهمل','مهمل','مهمل','مهمل','مهمل','مهمل','مهمل','مهمل','مهمل','تم الالغاء'],
                                ['مسوده','ارجاع','ارجاع','ارجاع','ارجاع','ارجاع','ارجاع','ارجاع','ارجاع','تم الالغاء'],
                                ['مسوده','تبديل','تبديل','تبديل','تبديل','تبديل','تبديل','تبديل','تبديل','تم الالغاء'],
                                ['مسوده','في الطريق','في الطريق','في الطريق','في الطريق','في الطريق','في الطريق','تم التوصيل','فشلت','تم الالغاء'],
        ]

        return(
            <div className="OrderData">
                  <div className="row text-center">
                                    <div className="col-3 border-left p-2">
                                        <p className="fontsize11  font-weight-bold "><span className="fontsize12">رقم الطلب : </span>  {this.props.state.ordernumber}</p>
                                    </div>
                                    <div className="col-4 border-left p-2">
                                        <p className="fontsize11  font-weight-bold "><span className="fontsize12">سعر الطلب : </span> {this.props.state.totalPrice} EGP</p>

                                    </div>
                                    <div className="col-5 p-2">
                                        <p className="fontsize11  font-weight-bold "><span className="fontsize12">تاريخ الطّلب : </span>{(this.props.state.date? moment(this.props.state.date).format("l") :'')}</p>
                                    </div>
                                </div>
                                <div className="row p-3">
                                    <div className="col-8">

                                        <img className="mx-4" src={deadline} alt="deadline" />
                                        <span className="fontsize4  font-weight-bold mt-2">{(this.props.state.pickupdate? moment(this.props.state.pickupdate).format("l") :'')}</span>
                                    </div>

                                    <div className="col-4 text-right">
                                        <span className={"badge-pill "+handle_state[this.props.state.failedstatus][this.props.state.status]}>{handle_stateAR[this.props.state.failedstatus][this.props.state.status]}</span>
                                    </div>
                                </div>
                                <ul className="timeline">
                                    <li className="bg-white  "><div className=" py-3 mx-5 my-2">
                                    <p className="fontsize11 bluecolor">نقطة الاستلام</p>
                                    <p className="fontsize11 m-0">{this.props.state.pickupaddress_name}</p>
                                </div></li>
                                    <li className="bg-white "><div className=" py-3 mx-5 my-2">
                                    <p className="fontsize11 bluecolor">نقطة التوصيل</p>
                                    <p className="fontsize11 m-0">{this.props.state.dropoffaddress_name}</p>
                                </div></li>
                                </ul>
                                <p className="fontsize11 "> كمّية المنتج: {this.props.state.quantity} قطعه</p>
                                <hr />
                                <h3 className=" fontsize9 font-weight-bold">تفاصيل العميل</h3>
                                <div className="row pt-3">
                                    <div className="col-md-4 pt-5">
                                        <p className=" fontsize12 text-muted">العميل</p>
                                        <p className="fontsize11 font-weight-bold">{this.props.state.reciver}</p>
                                        <p className="fontsize11 mb-0">استلام: <span className="fontsize4  font-weight-bold bluecolor">  {(this.props.state.amount ? this.props.state.amount : '0')} جنيه  </span></p>

                                    </div>
                                    <div className="col-md-3 pt-5">
                                        <p className=" fontsize12 text-muted">رقم الهاتف</p>
                                        <p className="fontsize11 font-weight-bold">{this.props.state.phone}</p>

                                    </div>
                                    <div className="col-md-3">
                                        <QRCode
                                            bgColor="#FFFFFF"
                                            fgColor="#000000"
                                            level="Q"
                                            style={{ }}
                                            value={this.props.state.qrcode}
                                        />
                                    </div>
                                </div>{(this.props.state.failedstatus === 1&& this.props.state.status === 4?
                    <div className="row">
                        <div className="col-md-3"><Link to={"/AR/Replaceorder/"+this.props.state.ordernumber} className="pointer"><img className="ml-3" src={replace} alt="replace" /><span className="bluecolor">تبديل العميل</span></Link></div>
                        <div className="col-md-3"><a className="pointer" data-toggle="collapse" href="#returnx" role="button" aria-expanded="false" aria-controls="collapseExample"><img className="ml-3" src={returnx} alt="return" /><span className="bluecolor">ارجاع</span></a></div>
                        <div className="col-md-3"><a className="pointer" data-toggle="modal" data-target="#trash"><img className="ml-3" src={trash} alt="trash" /><span className="bluecolor">التخلي عن الشحنه</span></a></div>
                        <div className="modal fade" id="trash" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            {/* Modal  */}
                            <div className="modal-dialog" role="document">
                                <div className="modal-content ">

                                    <div className="modal-body px-lg-5 mt-lg-4 text-center p2">
                                        <p className="fontsize4">هل أنت متأكد من أنك تريد حذف الطلب المحدد؟ سيتم التخلص من النفايات بشكل دائم ولن تتمكن من استعادتها</p>
                                    </div>
                                    <div className="modal-footer text-center d-flex justify-content-around  flex-wrap my-3">
                                        <button type="button" onClick={this.props.handetrash} data-dismiss="modal" className="btn my-1 badge-pill  btn-primary">yes</button>
                                        <button type="button" className="btn  badge-pill my-1 border shadow" data-dismiss="modal">No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* collapse  */}
                        <div className="collapse mt-2 col-10" id="returnx">
                            <div className="card card-body px-lg-5">
                                <MapsNewOrder setStatecoordinatesaddress_alias={this.props.setStatecoordinatesaddress_alias} state={this.props.state} />
                                <div className="col-md-12 p-3 px-lg-5">
                                    <div className="form-group relative search_div" id="pac-container">
                                        <img className="ml-1 img_input" src={searchbule} alt="search" />
                                        <input type="text " id="pac-input" className={"px-5 search_input form-control badge-pill " + (this.props.state.address_nameError ? 'is-invalid' : '')} placeholder="Location" name="اختار العنوان" value={this.props.state.address_name} onChange={this.props.handleChange} />
                                        <div style={{ fontSize: 12, color: "red" }} className="text-right">
                                            {this.props.state.address_nameError}
                                        </div>
                                    </div>

                                    <div id="map"></div>
                                    <div className="form-group col-12 text-right mt-2">
                                        <label >تفاصبل العنوان</label>
                                        <input type="text" className={"form-control badge-pill p-3 " + (this.props.state.address_aliasError ? 'is-invalid' : '')} placeholder="تفاصبل العنوان" name="address_alias" value={this.props.state.address_alias} onChange={this.props.handleChange} />
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.props.state.address_aliasError}
                                        </div>
                                    </div>
                                    <p className="  fontsize11 font-weight-bold " >سعر الاسترجاع : <span className=" fontsize11 font-weight-bold  float-left">20 EGP</span></p>
                                    <p className=" mt-3 fontsize11 font-weight-bold " >السعر النهائي : <span className=" fontsize11 font-weight-bold  float-left">70 EGP</span></p>

                                </div>
                                <button onClick={this.props.handleReturnOrderLocation} className="text-white badge-pill p-2 pl-1 px-3 border shadow bluebg text-center m-3">تاكيد</button>
                            </div>
                        </div>
                        
                    </div>

                    : '')}

                                <hr />
                                <p className="fontsize12 text-muted">ملاحظات</p>
                                <p className="fontsize11 font-weight-bold">{this.props.state.deliverynote}</p>
            </div>            

        )
    }
}
export default OrderData;